export default __webpack_public_path__ + "static/media/diego.png.webp";